// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "../static-" + (["1.24794"][{"88":0,"387":0,"617":0,"771":0,"798":0,"889":0}[chunkId]] || "1.24795") + "/" + chunkId + ".js";
};